module.exports = () =>
  new Promise(resolve => setTimeout(resolve));
